import image1 from "../assets/testimonials/compressed-t-image1.png";
import image2 from "../assets/testimonials/compressed-t-image2.png";
import image3 from "../assets/testimonials/compressed-t-image3.png";
import image4 from "../assets/testimonials/compressed-t-image4.png";
import image5 from "../assets/testimonials/compressed-t-image5.png";
import image6 from "../assets/testimonials/compressed-t-image6.png";
import image7 from "../assets/testimonials/compressed-t-image7.png";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I have been going to this gym for months now and I can confidently say that it is one of the best gyms I have ever been to. The coach is fantastic, and the classes are always challenging and fun.",
    name: "YUVI",
    status: "COACH",
  },
  {
    image: image2,
    review:
      "The gym is excellent and the coach is very supportive and attentive. I always feel like I am getting the personalized attention I need to improve my fitness level.",
    name: "LOVEY",
    status: "CUSTOMER",
  },
  {
    image: image3,
    review:
      "The gym and coach are simply amazing! The equipment is top-notch, and the facility is always clean and well-maintained. The coach is very knowledgeable and always goes the extra mile to help me achieve my fitness goals.",
    name: "INTE KHAB",
    status: "CUSTOMER",
  },
  {
    image: image4,
    review:
      "I have been a member of this gym for years, and I can honestly say that the coach is one of the best in the business. Their expertise and experience are truly invaluable, and I would recommend this gym to anyone looking to improve their health and fitness.",
    name: "GAGAN",
    status: "COACH",
  },
  {
    image: image5,
    review:
      "I have been training with this coach for several months now, and I have seen amazing results. The coach is incredibly dedicated, and their knowledge of fitness and nutrition is second to none.",
    name: "JASS",
    status: "CUSTOMER",
  },
  {
    image: image6,
    review:
      "This gym is fantastic, and the coach is absolutely phenomenal. They always push me to my limits and help me achieve my fitness goals. I would highly recommend this gym to anyone looking for a challenging and supportive workout environment.",
    name: "Deep",
    status: "CUSTOMER",
  },
  {
    image: image7,
    review:
      "The coach at this gym is simply amazing! They are always willing to go the extra mile to help me achieve my fitness goals, and their knowledge of exercise science is truly impressive. The gym itself is also very well-maintained and has everything I need for a great workout.",
    name: "ALL",
    status: "CUSTOMERS & COACH",
  },
];
